import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Seo from "../components/seo/Seo";

const NotFound = () => {
  return (
    <>
      <Seo
        title="Page Not Found | Drax Hall Health Group"
        description="The page you’re looking for can’t be found. Return to the homepage or choose a service."
        canonicalPath="/404"
        ogImage="/main-logo.png"
        noindex
      />
      <Box
        sx={{
          minHeight: "70vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          px: 2,
          gap: 2,
        }}
      >
        <Typography variant="h1" sx={{ fontSize: { xs: "2rem", md: "3rem" } }}>
          Page not found
        </Typography>
        <Typography variant="body1" sx={{ maxWidth: 520 }}>
          We couldn’t find the page you requested. Please go back home or choose
          one of our services to continue.
        </Typography>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", justifyContent: "center" }}>
          <Button variant="contained" component={RouterLink} to="/" color="primary">
            Go home
          </Button>
          <Button variant="outlined" component={RouterLink} to="/medical">
            Medical & Surgical
          </Button>
          <Button variant="outlined" component={RouterLink} to="/dental">
            Family Dental
          </Button>
          <Button variant="outlined" component={RouterLink} to="/physiotherapy">
            Physiotherapy & Rehab
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default NotFound;

